<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("intelbras.name", 2) }}</label>
        <b-form-input
          v-model="localSearchQuery"
          class="w-100"
          :calculate-position="withPopper"
          @input="updateSearchQuery"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("unit.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="facilitiesFilter"
          :options="facilities"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:facilitiesFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("centers.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="centerFilter"
          :options="centers"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:centerFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("sectors.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorFilter"
          :options="sectors"
          class="w-100"
          s
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:sectorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import { update } from "lodash";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
    facilities: {
      type: Array,
      default: [],
    },
    facilitiesFilter: {
      default: null,
    },
    centers: {
      type: Array,
      default: [],
    },
    centerFilter: {
      default: null,
    },
    sectors: {
      type: Array,
      default: [],
    },
    sectorFilter: {
      default: null,
    },
  },
  data() {
    return {
      localSearchQuery: this.searchQuery
    };
  },
  watch: {
    searchQuery(val) {
      this.localSearchQuery = val;
    },
  },
  methods: {
    updateSearchQuery() {
      this.$emit("update:searchQuery", this.localSearchQuery);
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
